import React, { Component } from "react";

import Cheque from "./components/Cheque/Cheque";
import Card from "./components/Card/Card";
import { getProductById, getCategoryById } from "./api";

import "./App.css";

class App extends Component {
  state = {
    product: null,
  };

  componentDidMount() {
 
    
    const id = (process.env.REACT_APP_STAGE==='dev')? 3 :  document.getElementById("product_id").value;


    getProductById(id).then(async (product) => {
     // console.log(product);
      //let category = await getCategoryById(product.product.id_category_default);
     // product.product.id = id;
    //  product.product.category = category.category.name;
      this.setState({ product: product.product });
    });
  }

  render() {
    const { product } = this.state;
    if (!product) return <div></div>;

    return (
      <div className="App">
        {product.id_category_default === process.env.REACT_APP_CARD_CATEGORY_ID ? (
          <Card product={product} />
        ) : (
          <Cheque product={product} />
        )}
      </div>
    );
  }
}

export default App;
